import "/__w/1/s/BotFramework-WebChat/packages/bundle/src/adaptiveCards/Attachment/VideoCardContent.module_built.css";
const classes = {"video-card-attachment":"wddVVaa_video-card-attachment"}
export default classes

const _video_card_attachment0 = classes["video-card-attachment"]
export { _video_card_attachment0 as "video-card-attachment" }
